export const DMS_MODULE = 'Sklady';
export const NAME = 'PneuSklad';
export const POLOZKY = 'PneuSkladPolozky';
export const CRUMB_LABEL_LIST = 'fltPneusklad';
export const CRUMB_LABEL_EDIT = 'edtPneusklad';

export const MAX_POCET_PNEU = 5;
export const DEFAULT_POCET_PNEU = 4;
export const POLOZKA_PREFIX = 'pneuForm';
